import styled from 'styled-components';
import { Button } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import React from 'react';

const ErrorImage = styled.img`
  width: 100%;
  max-width: 190px;
`;

const Title = styled.div`
  color: var(--gray-gray-400, #505050);
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
`;

const SubTitle = styled.div`
  color: var(--gray-gray-400, #505050);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
`;

const Text = styled.div`
  color: var(--gray-gray-300, #707070);
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  margin-bottom: 16px;
`;

const Layout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 0px 16px 70px 16px;
`;

const ErrorTable = ({ handleCloseError }) => {
  const { t } = useTranslation();
  return (
    <>
      <Layout>
        <ErrorImage src="errorconection.svg" alt="error" id="transactions-see-detail-error" />
        <Title>{t('transactions.modalDetail.errorTitle')}</Title>
        <SubTitle>{t('transactions.modalDetail.errorSubTitle')}</SubTitle>
        <Text>{t('transactions.modalDetail.errorDetail')}</Text>
        <Button onClick={handleCloseError} id="transactions-see-detail-failure-close">
          {t('transactions.modalDetail.errorButton')}
        </Button>
      </Layout>
    </>
  );
};

export default ErrorTable;
